<template>
  <div>
    <sv-header :asset="asset" title="Over mij"/>
    <v-container>
      <sv-page-title title="Nicole Loeve"></sv-page-title>
      <editable-field field-id="over_mij" v-if="fields"></editable-field>
      <v-btn class="primary white--text mb-3" :to="{name:'contact'}">Neem contact op</v-btn>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {
    asset() {
      return require("@/assets/sv/headers/overmij.jpg");
    },
    fields() {
      return this.$store.getters.fields;
    }
  }
};
</script>

<style lang="scss">
</style>
